import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config/config.service';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { ColumnInfo, PreviewTableComponent } from '../../../preview-table/preview-table.component';
import { ColumnLookupDataType, ColumnLookupRule, ConditionEndType, ConditionStartType, LookupDedup } from 'src/app/domainObjects/transformers/columnLookupTransform';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { LogicOperatorType } from 'src/app/domainObjects/logicalOperatorType';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { ColoredTextFindReplaceItem, ColoredTextItem } from 'src/app/domainObjects/coloredTextItem';
import { ColumnFilterInfo } from 'src/app/views/previewTable/filterUI/column-filter/column-filter.component';
import { ColumnLookupTransformDetailViewModel, ColumnLookupRuleTypeUtil, ConditionStartTypeUtil, ConditionEndTypeUtil, LookupDedupUtil } from './columnLokupTransformDetailViewModel';
import { BaseTransformerUIComponent } from '../../../dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';
import { TransformPipelineService } from '../../../../services/transformPipeline/transform-pipeline.service';
import { ColumnFilter } from 'src/app/domainObjects/columnFilter';
import { DataDictionaryService } from '../../../../services/dataDictionary/data-dictionary.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormBuilder, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { SortBuilderComponent } from 'src/app/views/transform/sort-builder/sort-builder.component';
import { DataTransformConfigViewModel } from '../../../../viewModels/dataTransformConfigViewModel';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { ColumnLookupRuleViewModel } from './columnLokupRuleViewModel';
import { DataFarmType, DataFarmTypeUtil } from 'src/app/domainObjects/dataFarmType';
import { UserDataService } from 'src/app/services/user-data-service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { IncludeBuilderComponent } from '../../include-builder/include-builder.component';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';
import { LinkNodeViewModel } from 'src/app/domainObjects/nodeViewModel';
import { PreviewDataOptions } from 'src/app/domainObjects/previewDataOptions';
import { GetDataFarmPreviewRequest } from 'src/app/messaging/getDataFarmPreviewRequest';
import { PreviewType, TransformType, TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { DataDictionaryType } from 'src/app/domainObjects/dataDictionaryType';
import { collectDistinctSourceFields } from 'src/app/views/shared/utils/source-field.util';
import { ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { TransformerTopHeaderComponent } from '../../transformer-top-header/transformer-top-header.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { InputPrvwFilterViewModel } from 'src/app/viewModels/inputPrvwFilterViewModel';
import { SaveCurrntTransfrmcacheRequest } from 'src/app/messaging/saveCurrntTransfrmcacheRequest';
import { OptionItemDataType } from 'src/app/model/optionItem';

class ViewModel {
  activeFilters?: ColumnFilter[];
}

@Component({
    selector: 'app-column-lookup-transform-detail',
    templateUrl: './column-lookup-transform-detail.component.html',
    styleUrls: ['./column-lookup-transform-detail.component.css'],
    standalone: false
})
export class ColumnLookupTransformDetailComponent extends BaseTransformerUIComponent<ColumnLookupTransformDetailViewModel>
implements OnInit {

  /** Distinct Input Farm fields referenced by this config's rules (rule.keyField — NOT
   * rule.sourceField, which is a Lookup Farm field; Smart Sample only ever applies to the
   * Input Farm), Default Source Field (defKeyField) first — the Architect, 2026-09-26. */
  get columnLookupAvailableSourceFields(): string[] {
    const defaultField = this.viewModel?.defKeyField;
    const fromRules = collectDistinctSourceFields(this.viewModel?.rules, r => r.keyField);
    if (!defaultField) return fromRules;
    return [defaultField, ...fromRules.filter(f => f !== defaultField)];
  }

  selectedIndex: number = 0;
  isResultsPanelExpanded = false;
  isPreviewPanelExpanded = false;
  transformerInputPreviewCacheKey = "";
  lookupcolumncount:number=0;  
  dataSource: MatTableDataSource<ColumnLookupRuleViewModel>;
  previewDataViewModel: ImportDataViewModel;
  isRuleSetEmpty = true;
  isRuleExecuting = false;
  RuleTypeUtil = ColumnLookupRuleTypeUtil;
  LogicalOperatorType = LogicOperatorType;
  ConditionStartTypeUtil = ConditionStartTypeUtil;
  ConditionStartType=ConditionStartType;
  ConditionEndTypeUtil = ConditionEndTypeUtil;
  ConditionEndType=ConditionEndType;
  DataFarmTypeUtil = DataFarmTypeUtil;
  LookupDedupUtil=LookupDedupUtil;

  ConditionStartTypes = [
    ConditionStartType.Contents,
    ConditionStartType.LeftChars,
    ConditionStartType.RightChars,
    ConditionStartType.Before,
    ConditionStartType.After,
    ConditionStartType.Between
  ];

  ConditionEndTypes = [
    ConditionEndType.Contents,
    ConditionEndType.LeftChars,
    ConditionEndType.RightChars,
    ConditionEndType.Before,
    ConditionEndType.After,
    ConditionEndType.Between
  ];

  DataTypes = [
    ColumnLookupDataType.Integer,
    ColumnLookupDataType.Float,
    ColumnLookupDataType.Timestamp,
    ColumnLookupDataType.Duration,
    ColumnLookupDataType.String
  ];
  DataFarmTypes = [
    DataFarmType.ingest,
    DataFarmType.subTask,
    DataFarmType.task,
    DataFarmType.activity,
    DataFarmType.cases,
    DataFarmType.users,
    DataFarmType.behaviors,
     DataFarmType.master,
  ];
  LookupDedups = [
    LookupDedup.KeepLast,
    LookupDedup.KeepFirst,
    LookupDedup.NoDedup
  ];
  LookupFarms: LinkNodeViewModel[]= [];
  displayedColumns: string[] = [
    'actions',
    'index',
    'ruleName',
    'keyField',
    'lookupField',
    'conditionStart',
    'keyParams',
    'conditionEnd',
    'lookupParams',
    'sourceField',
    'targetField',
    // 'find',
    // 'replace',
    'findReplace',
    'matchAll',
    'ifNoMatch',
    'matchCase',
    'isEnabled',
    'mergeHits',
    'lookupHits'];

  isRulesMaximized = false;

  sortCtrl = new UntypedFormControl('');
  includeCtrl = new UntypedFormControl('');

  form: FormGroup;
  formparam: FormGroup;

  inputPrvwFilterViewModel = new InputPrvwFilterViewModel();

  constructor(
    activeRoute: ActivatedRoute,
    errorService: ErrorReportingService,
    matDialog: MatDialog,
    snackBar: MatSnackBar,
    router: Router,
    configViewModelService: ConfigViewModelService,
    configService: ConfigService,
    navService: NavigationService,
    transformPipelineService: TransformPipelineService,
    userData: UserDataService,
    dataDictService: DataDictionaryService,
    refineryPresence: RefineryPresenceService,
    private cdRef: ChangeDetectorRef,private fb: FormBuilder ) {

      super(activeRoute, errorService, matDialog, snackBar, router, configViewModelService, configService, navService, transformPipelineService, userData,dataDictService, refineryPresence);
      this.transformType = TransformType.columnLookup;
  }
  globalStat: boolean;
  //other parameters
  defKeyField:ParameterSetting=new ParameterSetting();
  defLookupField:ParameterSetting=new ParameterSetting();
  lookupFarm:ParameterSetting=new ParameterSetting();
  lookupDedup:ParameterSetting=new ParameterSetting();
  resetRows: ParameterSetting=new ParameterSetting();
  overwriteRows: ParameterSetting=new ParameterSetting();
  //advanced settings parameters

  @ViewChild(TransformerTopHeaderComponent) topHeaderComponent: TransformerTopHeaderComponent;
  transformType:TransformType;
  options: string[] =[];
  optionsLookup: string[] =[];
 // optionsTarget: string[] =[];
  defaultSourceColumn='Source Field';
  defaultTargetColumn='Target Field';
   defaultLookupColumn='Lookup Field';
 defaultKeyColumn='Key Field';
 
  ngOnInit(): void {
    super.ngOnInit();
    this.userData.setInputTabClicked(false);
    this.userData.setLookupTabClicked(false);
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.resetInputPrvwViewModel();
    this.transformerInputPreviewCacheKey = "";
    //validation
    //for now parameter true as no 4 params not in common para
    this.isParameterFormValid = true;
    this.formparam = this.fb.group({
      defKeyField: [null, [Validators.required]],
      defLookupField: [null, [Validators.required]],
      lookupFarm: [null, [Validators.required]],
      lookupDedup: [0]
    });
    this.registerFormGroup(this.formparam);
    this.form = this.fb.group({
      
    });
    this.registerFormGroup(this.form);
    // Defensive guard, 2026-10-02: getMasterTransformers() can come back undefined on a
    // reload/deep-link/restored-tab landing directly on this route before
    // AppComponent.ensureMasterConfigsResolved() finishes its fetch (or if the cache was
    // manually cleared) -- an unguarded .find() here crashed ngOnInit outright, leaving the
    // rest of this component's initialization (below) never run, which is what produced a
    // half-rendered page. Defaults to true (show the stats panel) rather than crashing;
    // self-corrects next time this component initializes once the cache is populated.
    var masterconfig = this.userData.getMasterTransformers();
    this.globalStat = masterconfig?.find(x=>x.id==this.transformType)?.globalstat ?? true;
    //this.totalRulesColumnDisplay();
  }

  protected override async onRouteActivated(_routeParams: any): Promise<void> {
    this.viewModel = new ColumnLookupTransformDetailViewModel(
      this.dataDictService,
      this.configService,
      this.dataTransformConfigViewModel,
      this.transformViewModel);
    this.viewModel.farmType=this.userData.getSelectedNodeDetails().farmtypeid;
    this.configureTargetColumnsFarmtypeid(this.userData.getSelectedNodeDetails().farmtypeid);
    this.snapshotPreState();

    this.dataSource = new MatTableDataSource<ColumnLookupRuleViewModel>(this.viewModel.rules);
    this.isRuleSetEmpty = this.viewModel.rules.length === 0;

    var linkviewlist=this.userData.getSelectedNodeDetails();
    this.viewModel.farm=linkviewlist.id;
    this.viewModel.farmType=this.ConvertStringToEnum(linkviewlist.farmtypename);
    var parentnode=linkviewlist.sourcenodelink.find(x=>x.linetype=="line");
    this.viewModel.sourceDataFarm=parentnode.nodeid;
    this.LookupFarms=linkviewlist.sourcenodelink.filter(x=>x.linetype=="dotted");

    if (this.previewTable) { this.previewTable.clear(); }
    if (this.outputDataFarmPreviewTable) { this.outputDataFarmPreviewTable.clear(); }

    await this.setTransformerDetails(this.transformType);
    await this.downloadInputDataAsync();
    this.viewModel.parameters.sourceColumns = this.viewModel.sourceColumns;
    this.viewModel.parameters.targetColumns=this.viewModel.targetColumns;
    await this.setDefaultValues(this.transformType);
    await this.removeInvalidValues();

    try {
      if(!this.viewModel.lookupFarm){
        this.viewModel.lookupFarm=this.LookupFarms[0].nodeid;
        this.viewModel.lookupFarmType=this.LookupFarms[0].farmtypename;
      }
      await this.lookupDataFarmPreviewTable.onRefreshClicked();
      this.options=[...this.viewModel.sourceColumns.map(col => col.text).sort((a, b) => a.localeCompare(b))];
    } catch(ex) {
      console.log("lookupFarm error "+ex);
    }
  }
  ngAfterViewInit(): void {
    //load lookup farm priview table
    
  }
  getTextWidth(text, font) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = font || getComputedStyle(document.body).font;
    return context.measureText(text).width;
  }
  
  resizeInput(e) {
    setTimeout ( () =>{
      var textwidth:number = 0;
      textwidth=this.getTextWidth(e.target.value,null);
      if(textwidth>60){
      e.target.style.width=textwidth+"px";
      }
    }, 0);
  }
  onTransformTextChanged(){
    this.viewModel.transformViewModel.name=this.viewModel.transform.name;
    var currenttransform=this.dataTransformConfigViewModel.transforms.find(x=>x.guid==this.viewModel.transform.guid);
    currenttransform.name=this.viewModel.transform.name;
    currenttransform.transform.name=this.viewModel.transform.name;
    var vartransform=this.transformslists.find(x=>x.guid==this.viewModel.transform.guid);
    vartransform.name=this.viewModel.transform.name;
  }
  dropTable(event: CdkDragDrop<MatTableDataSource<TransformRuleViewModel>>): void {
    const prevIndex = event.previousIndex;
    const currentItem: ColumnLookupRuleViewModel = event.item.data;
    currentItem.index = prevIndex;
    moveItemInArray(this.viewModel.rules, prevIndex, event.currentIndex);
    this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.rules;
  }
  
  onRunChanged(event: MatSlideToggleChange): void {
    this.viewModel.rules.forEach( r => r.run = event.checked);
  }

  toggleRulesHeight(): void {
    this.isRulesMaximized = !this.isRulesMaximized;
  }

  removeSortInfo(sortInfo: SortInfo): void {
    const index = this.viewModel.sortInfo?.indexOf(sortInfo);

    if (index >= 0) {
      this.viewModel.sortInfo?.splice(index, 1);
    }
  }
  
  showSortBuilder(): void {
    const dialog = this.matDialog.open(SortBuilderComponent, {
      data: {
        fields: this.viewModel.sourceColumns.map(c => c.text),
        sortItems: [...this.viewModel.sortInfo ?? []] // make copy of array so it doesn't edit actual list
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const items = result.sortItems;
      this.viewModel.sortInfo = items;
      //this.viewModel.sortInfoDisplay = this.viewModel.sortInfo.map(i => `${i.sortField} (${i.sortAscending ? 'asc' : 'desc'})}`).join(',');
      this.sortCtrl.setValue(null);
    });
  }

  removeIncludeInfo(includeInfo: IncludeInfo): void {
    const index = this.viewModel.includeInResults?.indexOf(includeInfo);

    if (index >= 0) {
      this.viewModel.includeInResults?.splice(index, 1);
    }
  }
  
  showIncludeBuilder(): void {
    const dialog = this.matDialog.open(IncludeBuilderComponent, {
      data: {
        fields: this.viewModel.sourceColumns.map(c => c.text),
        includeItems: [...this.viewModel.includeInResults ?? []] // make copy of array so it doesn't edit actual list
      }
    });

    dialog.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const items = result.includeItems;
      this.viewModel.includeInResults = items;
      //this.viewModel.sortInfoDisplay = this.viewModel.sortInfo.map(i => `${i.sortField} (${i.sortAscending ? 'asc' : 'desc'})}`).join(',');
      this.includeCtrl.setValue(null);
    });
  }
  onDeleteRule(rule: ColumnLookupRuleViewModel): void {
    this.showConfirmDialog('Delete Confirmation', `Are you sure you want to delete this rule?`, (confirmed) => {
      if (confirmed) {
        const index = this.viewModel.rules.indexOf(rule);
        this.viewModel.rules.splice(index, 1);
        this.viewModel.reindexRules();
        
        this.dataSource.data = this.viewModel.rules;
        this.isRuleSetEmpty = this.viewModel.rules.length === 0;
        //update rule table height
        if(this.viewModel.rules.length<=10){
          this.minrowcount=this.viewModel.rules.length;
        }else{
          this.minrowcount=10;
        }
        this.maxrowcount=this.viewModel.rules.length;
      }
    });
  }

  onDuplicateRule(sourceRule: ColumnLookupRuleViewModel): void {
    
    const vm = new ColumnLookupRuleViewModel(sourceRule.toRule());

    this.viewModel.rules.splice(sourceRule.index, 0, vm);
    this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.rules;

    //console.log(`rule inserted at index: ${sourceRule.index}`);
    //update rule table height
    if(this.viewModel.rules.length<=10){
      this.minrowcount=this.viewModel.rules.length;
    }else{
      this.minrowcount=10;
    }
    this.maxrowcount=this.viewModel.rules.length;
    if(vm.index==this.maxrowcount){this.isScrollBottom=true; }else{this.isScrollBottom=false;}
  }
  minrowcount:number=10;
  maxrowcount:number=100;
  isScrollBottom:boolean=true;
  addNewRule(): void {
    var isValidDefaultParam=true;
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==this.transformType);
    var params=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid).parameters.filter(n=>n.isruledefault==true);
    params.forEach(field => {
      if(field.jsonobject=="defKeyField"){
        if(!this.viewModel.defKeyField){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="defLookupField"){
        if(!this.viewModel.defLookupField){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="lookupFarm"){
        if(!this.viewModel.lookupFarm){
          isValidDefaultParam=false;
        }
      }
      // else if(field.jsonobject=="lookupDedup"){
      //   if(!this.viewModel.lookupDedup){
      //     isValidDefaultParam=false;
      //   }
      // }
    });

    if (!isValidDefaultParam) {
      this.displayError("Cannot add Rule unless Default field(s) are entered.","Please fix the validation error.");
      return;
    }
    const id = this.viewModel.rules.length;
    const rule = new ColumnLookupRule();
    //rule.transformId = this.viewModel.transform?.id;
    //rule.transformConfigId = this.viewModel.transformConfigId;
    rule.ruleId = null;
    rule.index = id;
    rule.keyField = this.viewModel.defKeyField;
    rule.lookupField = this.viewModel.defLookupField;
    rule.run=true;
    rule.conditionStart=ConditionStartType.Contents;
    rule.conditionEnd=ConditionEndType.Contents;
    rule.ifNoMatch="None";
    const vm = new ColumnLookupRuleViewModel(rule);

    this.viewModel.rules.push(vm);
    this.isRuleSetEmpty = false;
    this.dataSource.data = this.viewModel.rules;

    //console.log('rule added');
    //console.log(this.dataSource.data);
    //update rule table height
    if(this.viewModel.rules.length<=10){
      this.minrowcount=this.viewModel.rules.length;
    }else{
      this.minrowcount=10;
    }
    this.maxrowcount=this.viewModel.rules.length;
  }
  async refreshPreviewTableLookup(sender: PreviewTableComponent): Promise<void> {
    if (sender === this.lookupDataFarmPreviewTable) {
      await this.refreshLookupDataFarmPreviewAsync(sender);
    }else{
      this.refreshPreviewTable(sender);
    }
  }
  async onRefreshClicked(sender: PreviewTableComponent): Promise<void> {
    await this.refreshPreviewTableLookup(sender);
  }
  async refreshLookupDataFarmPreviewAsync(sender: PreviewTableComponent): Promise<void> {
    const busyIndicator = this.showBusyDialog('Downloading lookup data....');
    sender.isGettingData.next(true);

    try {
      var configJson = this.userData.getSelectedConfigJson();
      
      const dataSourceType = configJson.dataSourceType;
      const configconnector=configJson.dataConnectorMappings[0];
      var dataconnector=configconnector.dataConnector;
      delete dataconnector['dataSourceType'];
      //console.log('dataconnector = ', dataconnector);
      
      const dataConnectorMapping =  new DataConnectorMapping(
            configconnector.id,
            configconnector.name,
            configconnector.targetDataFarm,
            dataconnector,
            configconnector.columnMap,
            configconnector.guid,
            configconnector.masterColumnMapGuid
            // state.refineryConfigGuid,
            // state.nodeId,
            // state.nodename,
            // state.nodeType
          );
      const filters = sender.activeFilterSet?.map(f => {
        const filterInfo = new ColumnFilter();
        filterInfo.field = f.columnName;
        filterInfo.values = f.values;
        return filterInfo;
      });
      const options = new PreviewDataOptions(sender.pageIndex, sender.rowsPerPage,this.activeSortsSet,filters);
      
      //var refineryConfig = this.userData.getSelectedRefineryDetails() ;
      //const lookupIngestId=refineryConfig.nodes.find(node=>node.id==this.viewModel.lookupFarm).data.ingestId;
      var cachekeyRequest=await this.GetCacheKeyRequest(PreviewType.transLookupInput);
       var request :GetDataFarmPreviewRequest = null;
       request = new GetDataFarmPreviewRequest(
        cachekeyRequest.userId,
        cachekeyRequest.orgId,
        cachekeyRequest.refineryId,
        cachekeyRequest.nodeId,
        cachekeyRequest.transformId,
        cachekeyRequest.cacheKeyType,
        options);

        console.log(configJson.guid);
        console.log("====LOOKUP FARM DATA=======")
        console.log(this.viewModel.lookupFarm);
      
    //var inputDataforThisNode = this.configService.getInputDataForNode(parentNodes);
    ////console.log('input data frame for preview', inputDataforThisNode );

        //const request=["source",parentNodes[0].source]
      const response = await this.configService.getInputDataForNode(request);
      //console.log("JSON.stringify(response)-----------------------------------------------------------");
      //console.log(JSON.stringify(response));
      this.viewModel.lookupColumns=response.data.columns.map(x=>x.columnName).sort();
      sender.bindData(response.data, 'No input preview data');
      this.lookupcolumncount=response.data.columns.length;
      //Bind lookup data
      this.optionsLookup=[...this.viewModel.lookupColumns.map(col => col).sort((a, b) => a.localeCompare(b))];
      if(!this.viewModel.defLookupField){
        for(let pr of this.defLookupField.default.split(";")){
          const foundColumn = this.viewModel.lookupColumns.find(sc => sc == pr);
          if(foundColumn){
            this.viewModel.defLookupField=foundColumn;
            break;
          }
        }
      }
      console.log("this.optionsLookup ",this.optionsLookup);
      this.LoadSummaryPersistance(this.summaryDataFarmPreviewTableLookup, true);
      this.cdRef.detectChanges();
    } catch (err) {
      this.displayError('Failed to get data farm preview', 'Error', err);
    } finally {
      sender.isGettingData.next(false);
      busyIndicator.close();
    }
  }

  async onApplyFilter(sender: PreviewTableComponent, activeFilterSet: ColumnFilterInfo[],  info: ColumnFilterInfo): Promise<void> {
    const busyIndicator = this.showBusyDialog('Please wait...');
    if (sender === this.summaryDataFarmPreviewTableInput || sender === this.summaryDataFarmPreviewTableOutput || sender === this.summaryDataFarmPreviewTableLookup) {
      super.onApplyFilter(sender, activeFilterSet, info); 
    }
    await this.refreshPreviewTableLookup(sender);
    busyIndicator.close();
  }

  async onClearFilter(sender: PreviewTableComponent, activeFilterSet: ColumnFilterInfo[], columnName: string): Promise<void> {
    const busyIndicator = this.showBusyDialog('Please wait...');
    await this.refreshPreviewTableLookup(sender);
    busyIndicator.close();
  }

  async onPageChanged(sender: PreviewTableComponent,totalRows: number,pageSize: number,pageIndex: number): Promise<number> {
      const busyIndicator = this.showBusyDialog('Please wait...');
      await this.refreshPreviewTableLookup(sender);
      busyIndicator.close();
      return totalRows;
  }

  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, colInfos: ColumnInfo[]): string {
    
    try {
      if (sender === this.previewTable) {
        if (this.viewModel.sourceColumns && this.viewModel.sourceColumns.find(f => f.text === colInfo.name) === undefined) {
          return 'meta-data-column-color';
        }
        
        const missCol = colInfos.filter( col => {
          return col.name === 'ruleMiss';
        });

        if (missCol.length === 1) {
          if (row[missCol[0].index] === true) {
            return 'missedRuleRow';
          }
        }
      }else if (sender === this.summaryDataFarmPreviewTableResult) {
        if(colInfo.name.startsWith("smry_count")){
          if(this.colorSummaryCount!=""){
            this.colorSummaryCount="";
            return 'meta-data-column-color';
          }
        }else{
          if (this.viewModel.sourceColumns && this.viewModel.sourceColumns.find(f => f.text === colInfo.name) === undefined) {
            this.colorSummaryCount='meta-data-column-color';
            return 'meta-data-column-color';
          }
        }
        
        const missCol = colInfos.filter( col => {
          return col.name === 'ruleMiss';
        });

        if (missCol.length === 1) {
          if (row[missCol[0].index] === true) {
            return 'missedRuleRow';
          }
        }
      }
    } catch (err) {
      //console.log(err);
    }

    return null;
  }

  onContainsCellClicked(rule: ColumnLookupRuleViewModel): void {

    // this.showContainsEditorDialog([...rule.containsList], async (items: ColoredTextItem[]) => {
    //   rule.containsList = items;
    // });
  }

  showContainsEditorDialog(
    existingItems: ColoredTextItem[],
    onClosed: (items: ColoredTextItem[]) => any ): void {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {items: existingItems, textTypeName: 'Contains', title: 'Multiple contains Text Editor'};
    dialogConfig.width = '600px';
  }

  async saveConfig(): Promise<void> {
    if (!this.validate()) {
      return;
    }
    var isRuleValid=await this.validateRules();
    if(!isRuleValid){
      return;
    }

    //console.log(this.dataTransformConfigViewModel);

    if (this.dataTransformConfigViewModel.dataTransformerConfig?.id || this.dataTransformConfigViewModel.dataTransformerConfig?.guid) {
      //console.log('updating...');
      this.saveConfigImpl(this.dataTransformConfigViewModel.dataTransformerConfig.name);
    } else {
      //console.log('saving...');
      this.showSaveConfigDialog(async (configName: string) => {
        this.saveConfigImpl(configName);
      });
    }
  }

  async saveConfigImpl(configName: string): Promise<void> {
      var currenttransformer_sampleStart = this.viewModel.parameters.sampleStart ;
      var currenttransformer_sampleEnd = this.viewModel.parameters.sampleEnd  ;
    
        if (currenttransformer_sampleStart >=  currenttransformer_sampleEnd) {
            this.displayWarning(
              'Sample Start was greater than to Sample End, so it was auto-reset to 1.',
              'Warning',
              undefined,
              () => {
                this.viewModel.parameters.sampleStart = 1;
              }
            );
            return;
          }
          if(currenttransformer_sampleStart > this.totalInputRows || currenttransformer_sampleEnd > this.totalInputRows )
        {
    
          this.displayWarning(
            'Sample Range exceeded the Input Farm size and was auto-corrected to the maximum limit.',
            'Warning',
            undefined,  // no exception to pass
            () => {
           
              if (currenttransformer_sampleStart > this.totalInputRows) {
              this.viewModel.parameters.sampleStart = 1;
              }
              if (currenttransformer_sampleEnd > this.totalInputRows) {
                this.viewModel.parameters.sampleEnd = this.totalInputRows;
              }
            }
          );
          return;
        }
    const busyIndicator = this.showBusyDialog('Please wait...');
    try {
      let config = this.dataTransformConfigViewModel.dataTransformerConfig ?? new DataTransformerConfig();

      config.name = configName;
      config.organizationId = 1;
      config.dataSourceType = this.dataTransformConfigViewModel.dataSourceType;
      config.selectedIngestFarmGuid = this.dataTransformConfigViewModel.selectedIngestFarmGuid;
      
      // Save the Data Connectors
      config.dataConnectorMappings = this.dataTransformConfigViewModel.ingestConfigs
      .map ( ingestConfig =>
        new DataConnectorMapping(
          ingestConfig.id,
          ingestConfig.name,
          ingestConfig.targetDataFarm,
          ingestConfig.dataConnector.toDataConnector(),
          ingestConfig.columnMap
            .map(i => i.toColumnMapDefinition()),
          ingestConfig.guid,
          ingestConfig.masterColumnMapGuid)
      );

      //console.log('saving config...');
      //console.log(this.dataTransformConfigViewModel);

      // Save Transforms
      config.transforms = this.dataTransformConfigViewModel.transforms.map(t => t.transform);

      // Save the transform
      //const transform = config.transforms.find(t => t.id === this.viewModel.transform?.id) ?? this.viewModel.transformViewModel.transform;
      const transform = this.viewModel.transformViewModel.transform;
      //console.log(transform);

      transform.transformConfig = this.viewModel.toTransformConfig();
      // transform.dataFarmName = this.viewModel.dataFarm.name;
      // transform.dataFarmType = this.viewModel.dataFarm.dataFarmType;

      // TODO: Maintain list of transforms for this config
      const existingTransform = config.transforms.find(t => t.guid === transform.guid);
      if (existingTransform) {
        config.transforms.splice(config.transforms.indexOf(existingTransform), 1);
      }
      config.transforms.push(transform);
      
      // Save the ingest transforms
      //console.log(JSON.stringify(config));

      config = await this.configService.upsertConfig(config);
      //console.log('received new data transform config from server: ' + JSON.stringify(config));
      this.userData.setSelectedConfigJson(config);
      this.configViewModelService.setDataTransformConfigViewModel(new DataTransformConfigViewModel(config));
      this.userData.setSelectedTransform(this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid));
      //update preViewModel
      this.snapshotPreState();

      // SAve the current node status to Not RunConfigRequest.
      const selectedNode = this.userData.getSelectedNodeDetails();
      //const RefineryConfigJson = await this.configService.getRefineryConfigByGuidAsync(selectedNode.refineryConfigGuid);
      // //console.log('Refinery json in save = ', RefineryConfigJson) ;
      //RefineryConfigJson.nodes.filter(newNode => newNode.id == selectedNode.id)[0].data.nodeStatus = NodeRunStatus.NotRun
      //let RefineryJson = await this.configService.UpsertRefineryConfig(RefineryConfigJson);

      // var UpdateNodesStatus: UpdateNodesStatusRequest = new UpdateNodesStatusRequest(selectedNode.refineryConfigGuid, selectedNode.id, NodeRunStatus.PipelineModified )
      // let updateStatusreturn = await this.configService.updateUpcomingNodesStatus(UpdateNodesStatus);
      
      //Invoke the save current transformer cache api
       const activeTransformGuid = this.userData.getSelectedTransform().guid
       const userId = this.userData.getUserId()
       const orgId = this.userData.getOrgId()
       var saveCurrentTransformerCacheRequest: SaveCurrntTransfrmcacheRequest = new SaveCurrntTransfrmcacheRequest(userId, orgId, selectedNode.id, selectedNode.refineryConfigGuid, this.dataTransformConfigViewModel.selectedIngestFarmGuid, activeTransformGuid);
       await this.configService.saveCurrentTransformerCache(saveCurrentTransformerCacheRequest);
       await this.configService.getRefineryConfigByGuidAsync(this.userData.getRefineryId());
       this.getCacheStatus();
       // this.cdRef.detectChanges();
      this.snackBar.open(`Successfully saved transform pipeline '${this.userData.getSelectedTransform().name}'`, 'Dismiss', {
        duration: 5000
      });
    } catch (err) {
      this.displayError(`Failed to save '${this.userData.getSelectedTransform().name}'`, 'Error', err);
    } finally {
      busyIndicator.close();
    }
  }

  async onLookupFarmSelected(event: any): Promise<void> {
    if (event.value) { 
      var linkviewlist=this.userData.getSelectedNodeDetails();
      var farmtypename=linkviewlist.sourcenodelink.find(x=>x.nodeid==event.value).farmtypename;
      //console.log(`selected Look up farm sourcefarmtypename: ${farmtypename}`);
      this.viewModel.lookupFarmType=farmtypename;

      //await this.lookupDataFarmPreviewTable.onRefreshClicked();
      await this.refreshLookupDataFarmPreviewAsync(this.lookupDataFarmPreviewTable);
      const foundColumn = this.optionsLookup.find(sc => sc == this.viewModel.defLookupField);
      if(foundColumn){
        this.viewModel.defLookupField=foundColumn;
      }
      else{
        this.viewModel.defLookupField = null;
      }
      this.cdRef.detectChanges(); 
    }
  }

  onSetDefaultRule(defaultfield:string){
    if(defaultfield=="sourceColumn"){
      this.viewModel.rules.forEach(rule=>{
        rule.keyField=this.viewModel.defKeyField;
      })
    }
    else if(defaultfield=="targetColumn"){
      this.viewModel.rules.forEach(rule=>{
        rule.lookupField=this.viewModel.defLookupField;
      })
    }
  }
  totalRulesColumnDisplay(){
    //blank values
    this.viewModel.rules.forEach(rule=>{
      //rule.groupHits=null;
      //rule.rowHits=null;
    })
    if(this.viewModel.parameters.runAll){
      this.displayedColumns= [
        'actions',
        'index',
        'name',
        'sourceField',
        'actionString',
        'objectString',
        'timeout',
        'priorityString',
        'includeAction',
        'matchAll',
        'ignoreSpaces',
        'matchCase',
        'isEnabled',
        'sampleGroups',
        'sampleRows',
        'groups',
        'rows'];
      }else{
      this.displayedColumns= [
        'actions',
        'index',
        'name',
        'sourceField',
        'actionString',
        'objectString',
        'timeout',
        'priorityString',
        'includeAction',
        'matchAll',
        'ignoreSpaces',
        'matchCase',
        'isEnabled',
        'sampleGroups',
        'sampleRows'];
    }
    this.cdRef.detectChanges();
  }
  onToggleRulesColumnDisplay(){
    //this.totalRulesColumnDisplay();
  }
  onToggleMultiTarget(event: any){
    //this.viewModel.multiTargetColumn=event.checked;
  }
  onParameterFormStatusChange(status: boolean) {
    //this.isParameterFormValid = status;
  }

  checkContainsListLength(rule: any): boolean {
    return !rule.containsList || rule.containsList.length <= 1;
  }
  onSetDefaultRuleParam(defaultfield:string):void{
    this.showConfirmDialog('', `Fill Source Field in Rules Table with Default Source Field?`, async (confirmed) => {
      if (confirmed) {
        this.onSetDefaultRule(defaultfield);
      }
    }); 
  }


  ConvertStringToEnum(requst:string): number{
    var ret:number=-1;
    if(requst=="Subtask"){
      ret = DataFarmType.subTask;
    }
    else if(requst=="Task"){
      ret = DataFarmType.task;
    }
    else if(requst=="Activity"){
      ret = DataFarmType.activity;
    }
    else if(requst=="Case"){
      ret = DataFarmType.cases;
    }
    else if(requst=="User"){
      ret = DataFarmType.users;
    }
    else if(requst=="Behavior"){
      ret = DataFarmType.behaviors;
    }
    else if(requst=="Master"){
       ret = DataFarmType.master;
     // ret = 7;
    }
    return ret;
  }
  
  onConditionStartSelected(event: any,rule:any):void{
    if(rule.conditionStart==rule.conditionStartPre){
      rule.keyParams = rule.keyParamsPre;
    }else if(rule.conditionStart==ConditionStartType.Contents){
      rule.keyParams = '';
    }
    else if(rule.conditionStart==rule.conditionStartFrom){
      rule.keyParams = rule.keyParamsPre;
    }else if(rule.conditionStartFrom==ConditionStartType.LeftChars){
      if(rule.conditionStart!=ConditionStartType.RightChars){
        rule.keyParams = '';
      } 
    }else if(rule.conditionStartFrom==ConditionStartType.RightChars){
      if(rule.conditionStart!=ConditionStartType.LeftChars){
        rule.keyParams = '';
      } 
    }else if(rule.conditionStartFrom==ConditionStartType.Before){
      if(rule.conditionStart!=ConditionStartType.After){
        rule.keyParams = '';
      } 
    }else if(rule.conditionStartFrom==ConditionStartType.After){
      if(rule.conditionStart!=ConditionStartType.Before){
        rule.keyParams = '';
      }  
    }else {
      rule.keyParams = '';
    }
    rule.conditionStartFrom=rule.conditionStart;
  }
  checkKeyParamsNumber(rule:any):void{
    if(rule.conditionStart==ConditionStartType.LeftChars){
      if (isNaN(Number(rule.keyParams)) || rule.keyParams.trim() === '') {
        rule.keyParams = '';
      }
    }else if(rule.conditionStart==ConditionStartType.RightChars){
      if (isNaN(Number(rule.keyParams)) || rule.keyParams.trim() === '') {
        rule.keyParams = '';
      }
    }
  }
  checkKeyParamsOut(rule:any):void{
    if(rule.conditionStart==ConditionStartType.Between){
      // Check if a comma is present
      const commaIndex = rule.keyParams.indexOf(',');
      if (commaIndex !== -1) {
        // Get the substring after the comma and trim spaces
        const afterComma = rule.keyParams.substring(commaIndex + 1).trim();
        // If no characters after the comma, clear the input field
        if (afterComma === '') {
          rule.keyParams = '';
        }
      }else {
        rule.keyParams = '';
      } 
    }
  }
  onConditionEndSelected(event: any,rule:any):void{
    if(rule.conditionEnd==rule.conditionEndPre){
      rule.lookupParams = rule.lookupParamsPre;
    }else if(rule.conditionEnd==ConditionEndType.Contents){
      rule.lookupParams = '';
    }
    else if(rule.conditionEnd==rule.conditionEndFrom){
      rule.lookupParams = rule.lookupParamsPre;
    }else if(rule.conditionEndFrom==ConditionEndType.LeftChars){
      if(rule.conditionEnd!=ConditionEndType.RightChars){
        rule.lookupParams = '';
      } 
    }else if(rule.conditionEndFrom==ConditionEndType.RightChars){
      if(rule.conditionEnd!=ConditionEndType.LeftChars){
        rule.lookupParams = '';
      } 
    }else if(rule.conditionEndFrom==ConditionEndType.Before){
      if(rule.conditionEnd!=ConditionEndType.After){
        rule.lookupParams = '';
      } 
    }else if(rule.conditionEndFrom==ConditionEndType.After){
      if(rule.conditionEnd!=ConditionEndType.Before){
        rule.lookupParams = '';
      }  
    }else {
      rule.lookupParams = '';
    }
    rule.conditionEndFrom=rule.conditionEnd;
  }
  checkLookupParamsNumber(rule:any):void{
    if(rule.conditionEnd==ConditionEndType.LeftChars){
      if (isNaN(Number(rule.lookupParams)) || rule.lookupParams.trim() === '') {
        rule.lookupParams = '';
      }
    }else if(rule.conditionEnd==ConditionEndType.RightChars){
      if (isNaN(Number(rule.lookupParams)) || rule.lookupParams.trim() === '') {
        rule.lookupParams = '';
      }
    }
  }
  checkLookupParamsOut(rule:any):void{
    if(rule.conditionEnd==ConditionEndType.Between){
      // Check if a comma is present
      const commaIndex = rule.lookupParams.indexOf(',');
      if (commaIndex !== -1) {
        // Get the substring after the comma and trim spaces
        const afterComma = rule.lookupParams.substring(commaIndex + 1).trim();
        // If no characters after the comma, clear the input field
        if (afterComma === '') {
          rule.lookupParams = '';
        }
      }else {
        rule.lookupParams = '';
      } 
    }
  }

  onTabClick(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    this.selectedIndex = selectedTabIndex;
 
    // Alert the tab index and label
   // alert(`Tab clicked: ${selectedTabLabel} (Index: ${selectedTabIndex})`);
    if(selectedTabLabel.match("Input") && selectedTabIndex == 0) {
      this.userData.setLookupTabClicked(false);
      this.userData.setResultsTabClicked(false);
      this.userData.setOutputTabClicked(false);
      this.setInputPreviewFilterViewModel();
    } else if(selectedTabLabel.match("Lookup") && selectedTabIndex == 1) {
      this.userData.setLookupTabClicked(true);
      this.userData.setResultsTabClicked(false);
      this.userData.setOutputTabClicked(false);
      this.setLookupPreviewFilterViewModel();
    } else {
      this.userData.setLookupTabClicked(false);
      this.userData.setOutputTabClicked(false);
      if(selectedTabLabel.match("Output") && selectedTabIndex == 2) {
        this.setOutputPreviewTabSlctnStatus();
      }
      // if(selectedTabLabel.match("Summary") && selectedTabIndex == 3) {
      //   if(this.source.length > 0) {
      //     let selectFilterInfoSummary = new SelectFilterInfo(this.source, this.selectFilterValues);
      //     this.onApplySelect(selectFilterInfoSummary);
      //   }
      // }
    }
  }  

  setColumnLookupResultsTabClicked(): void {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    this.userData.setOutputTabClicked(false);
    this.userData.setResultsTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    this.isResultsPanelExpanded = true;
    this.isPreviewPanelExpanded = false;
  }

  setColLookupPreviewTabClicked(): void {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    this.isResultsPanelExpanded = false;
    this.isPreviewPanelExpanded = true;
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    if(this.selectedIndex == 0) {
      this.setInputPreviewFilterViewModel()
    } else if(this.selectedIndex == 1) {
      this.setLookupPreviewFilterViewModel();
    } else if(this.selectedIndex == 2) {
      this.setOutputPreviewTabSlctnStatus();
    }
  }

  setInputPreviewFilterViewModel() {
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.setTransformerInputPrvwCacheKey();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel)
  }

  setTransformerInputPrvwCacheKey() {
    if(this.transformerInputPreviewCacheKey.length > 0 && this.inputPrvwFilterViewModel.farmId.length > 0) {
      this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = this.transformerInputPreviewCacheKey;
      this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    }
  }

  resetTransformerInputPrvwModelData() {
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
    this.inputPrvwFilterViewModel.previewType = "";
  }

  setLookupPreviewFilterViewModel() {
    this.inputPrvwFilterViewModel.collookupFarmId = this.viewModel.lookupFarm;
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
  }

  resetInputPrvwViewModel() {
    this.inputPrvwFilterViewModel.farmId = "";
    this.inputPrvwFilterViewModel.collookupFarmId = "";
    this.inputPrvwFilterViewModel.nodeType = "";
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
  }

  setOutputPreviewTabSlctnStatus(): void {
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(true);
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
  }

  
  get isValidateParameters(): boolean {
    return !(this.isParameterFormValid && this.formparam.valid);
  }
  get isValidateAdvanceSettings(): boolean {
    return this.form.invalid;
  }
  onFindReplaceCellClicked(rule: ColumnLookupRuleViewModel): void {
    let title: string=`Chooser (Find & Replace): Rule ${rule.index}${rule.ruleName ? ' - ' + rule.ruleName : ''}`;
    let labelFind: string="Find";
    let labelReplace: string="Replace";
    let placeholderFind: string="Enter find";
    let placeholderReplace: string="Enter replace";
    let fieldType: string="edit";
    let isDuplicateRemoved: boolean=false;
    let canAddNewAutocomplete: boolean=false;
    let optionsFind: OptionItemDataType[]=[];
    let optionsReplace: OptionItemDataType[]=[];
    let validateboth: boolean=false;
    let isDataTypeCheck: boolean=false;
    let dialogWidth: string='650px';
    this.showFindReplaceEditorDialogOption(title,labelFind,labelReplace,placeholderFind,placeholderReplace,fieldType,isDuplicateRemoved,canAddNewAutocomplete,optionsFind,optionsReplace,validateboth,isDataTypeCheck,dialogWidth,
      [...rule.findReplaceList],
      async (items: ColoredTextFindReplaceItem[],eventname:string) => {
        if(eventname=='save'){
        rule.findReplaceList = items;
        }
      });
  }

  onToggleResetRows(event: any){
    this.viewModel.resetRows=event.checked;
  }
  onToggleOverwriteRows(event: any){
    this.viewModel.overwriteRows=event.checked;
  }

  async validateRules(): Promise<boolean> {
    let isValid = true;
    let validType="";
    try{
      var dataDictionaryItems =await this.getDataDictOptionItemDataTypePD(this.userData.getSelectedNodeDetails().farmtypeid);
      // Guard, 2026-10-02 (revised after live testing): a Run clicked before the Lookup/Input
      // preview tables finish loading their own column lists originally crashed deep in the
      // loop below with a cryptic "Cannot read properties of undefined (reading 'find')". A
      // first fix made this a hard, user-facing block instead -- but that then fired on a
      // perfectly normal Run clicked shortly after page load, before this unrelated preview
      // data had caught up (onRouteActivated's own `await
      // this.lookupDataFarmPreviewTable.onRefreshClicked()` resolves before the component's
      // displayedColumnInfos is actually populated by its internal subscription, not after).
      // This client-side source/target data-type check is a pre-flight nicety, not something
      // the real server-side Run depends on -- confirmed directly: Run succeeded even when this
      // exact check crashed. So: poll briefly for the normal race to resolve on its own, and if
      // it genuinely never does, skip this one check rather than blocking a legitimate Run.
      const previewTablesReady = await this.waitForLookupInputPreviewReady(3000);
      if (!previewTablesReady) {
        console.warn('validateRules: skipping source/target data-type pre-check -- Lookup/Input farm preview did not finish loading in time.');
        return true;
      }
      for (const rule of TransformRuleViewModel.enabledRules(this.viewModel.rules)){   // a rule that is off is not checked
        var sourceField="";
        var targetField="";
        var ifNoMatch="";
        var sourceFieldColumnInfo =this.lookupDataFarmPreviewTable.displayedColumnInfos.find(col=>col.name==rule.sourceField);
        if(!sourceFieldColumnInfo){
          this.displayError(TransformRuleViewModel.ruleMessage(rule, `Source Field (${rule.sourceField ?? 'not set'}) is not a field in the lookup farm.`), 'Error');
          return false;
        }else{
          sourceField=sourceFieldColumnInfo.pydataType;
        }
        var targetFieldColumnInfo =dataDictionaryItems.find(item=>item.value==rule.targetField);
        if(!targetFieldColumnInfo){
          this.displayError(TransformRuleViewModel.ruleMessage(rule, `Target Field (${rule.targetField ?? 'not set'}) is not a field of the Data Dictionary.`), 'Error');
          return false;
        }else{
          targetField=targetFieldColumnInfo.dataType;
        }
        
        if(rule.ifNoMatch!="None"){
          var ifNoMatchColumnInfo =this.inputDataFarmPreviewTable.displayedColumnInfos.find(col=>col.name==rule.ifNoMatch);
          if(!ifNoMatchColumnInfo){
            this.displayError(TransformRuleViewModel.ruleMessage(rule, `Value if no match (${rule.ifNoMatch}) is not a field in the input farm.`), 'Error');
            return false;
          }else{
          ifNoMatchType=ifNoMatchColumnInfo.pydataType;
        }
        }
        var sourceFieldType=sourceField;
        var targetFieldType=targetField;
        var ifNoMatchType=ifNoMatch;

        sourceField=this.getNormalizedDataType(sourceField);
        ifNoMatch=this.getNormalizedDataType(ifNoMatch);
        targetField=this.getNormalizedDataType(targetField);
        
        const sourceFormField = document.querySelector('#sourceField'+rule.index);
        if (sourceFormField && sourceFormField.classList.contains('red')) {
          sourceFormField.classList.remove('red');
          sourceFormField.classList.add('orange');
        }
        const targetFormField = document.querySelector('#targetField'+rule.index);
        if (targetFormField && targetFormField.classList.contains('red')) {
          targetFormField.classList.remove('red');
          targetFormField.classList.add('orange');
        }
        const ifNoMatchFormField = document.querySelector('#ifNoMatch'+rule.index);
        if (ifNoMatchFormField && ifNoMatchFormField.classList.contains('red')) {
          ifNoMatchFormField.classList.remove('red');
        }
        console.log("ifNoMatch ",ifNoMatch);
        if(rule.ifNoMatch=="None"){
          if(sourceField!=targetField){
            isValid = false;
            if(validType==""){
              //this.displayWarning(TransformRuleViewModel.label(rule)+": Source Field, Target Field & If No match (Field) must all be the same data type.  Please correct before proceeding.","Rules Validation Error");
              this.displayWarning(TransformRuleViewModel.ruleMessage(rule, "Source Field ("+sourceFieldType+") & Target Field ("+targetFieldType+") must all be the same data type.  Please correct before proceeding."),"Rules Validation Error");
            }
            validType="mismatchdatatype";
            sourceFormField?.classList.remove('orange');
            sourceFormField?.classList.add('red');
            targetFormField?.classList.remove('orange');
            targetFormField?.classList.add('red');
          }
        }else{
          if(sourceField!=targetField || sourceField!=ifNoMatch ||  targetField!=ifNoMatch){
            isValid = false;
            if(validType==""){
              //this.displayWarning(TransformRuleViewModel.label(rule)+": Source Field, Target Field & If No match (Field) must all be the same data type.  Please correct before proceeding.","Rules Validation Error");
              this.displayWarning(TransformRuleViewModel.ruleMessage(rule, "Source Field ("+sourceFieldType+"), Target Field ("+targetFieldType+") & If No match ("+ifNoMatchType+") (Field) must all be the same data type.  Please correct before proceeding."),"Rules Validation Error");
            }
            validType="mismatchdatatype";
            sourceFormField?.classList.remove('orange');
            sourceFormField?.classList.add('red');
            targetFormField?.classList.remove('orange');
            targetFormField?.classList.add('red');
            ifNoMatchFormField?.classList.add('red');
          }
        }
        //Don't allow Key & Lookup Fields to be in Source & Target Fields
        const keyFormField = document.querySelector('#keyField'+rule.index);
        if (keyFormField && keyFormField.classList.contains('red')) {
          keyFormField.classList.remove('red');
          keyFormField.classList.add('green');
        }
        const lookupFormField = document.querySelector('#lookupField'+rule.index);
        if (lookupFormField && lookupFormField.classList.contains('red')) {
          lookupFormField.classList.remove('red');
          lookupFormField.classList.add('green');
        }
        if(rule.keyField==rule.targetField && rule.lookupField==rule.sourceField){
          isValid = false;
          if(validType==""){
            this.displayWarning(TransformRuleViewModel.ruleMessage(rule, "The Key Field cannot be selected as the Target Field and the Lookup Field cannot be selected as the Source Field "),"Rules Validation Error");
          }
          validType="matchall";
          keyFormField?.classList.remove('green');
          keyFormField?.classList.add('red');
          targetFormField?.classList.remove('orange');
          targetFormField?.classList.add('red');
          lookupFormField?.classList.remove('green');
          lookupFormField?.classList.add('red');
          sourceFormField?.classList.remove('orange');
          sourceFormField?.classList.add('red');
        }
        else if(rule.keyField==rule.targetField){
          isValid = false;
          if(validType==""){
            this.displayWarning(TransformRuleViewModel.ruleMessage(rule, "The Key Field cannot be selected as the Target Field."),"Rules Validation Error");
          }
          validType="keytarget";
          keyFormField?.classList.remove('green');
          keyFormField?.classList.add('red');
          targetFormField?.classList.remove('orange');
          targetFormField?.classList.add('red');
        }
        else if(rule.lookupField==rule.sourceField){
          isValid = false;
          if(validType==""){
            this.displayWarning(TransformRuleViewModel.ruleMessage(rule, "The Lookup Field cannot be selected as the Source Field."),"Rules Validation Error");
          }
          validType="looksource";
          lookupFormField?.classList.remove('green');
          lookupFormField?.classList.add('red');
          sourceFormField?.classList.remove('orange');
          sourceFormField?.classList.add('red');
        }
      }
    }catch (err) {
      // Fixed 2026-10-02: this previously copy-pasted loadImportTransformer()'s error message
      // ("Failed to save import transformer") verbatim, even though this function has nothing
      // to do with importing -- confusing whenever an unexpected exception here (e.g. a
      // preview table not yet loaded) surfaced it. It also previously returned whatever
      // `isValid` happened to be before the exception (true, by default), letting Run proceed
      // despite validation never actually completing -- fail safe instead.
      this.displayError(`Rule validation failed unexpectedly.`, 'Error', err);
      isValid = false;
    }finally {
      //busyIndicator.close();
    }
    return isValid;
  }

  /** Polls every 200ms, up to timeoutMs, for the Lookup/Input preview tables' own column
   * lists to be populated. Normally resolves almost immediately (this is a brief load race,
   * not a real failure) -- the bound exists only so a genuine problem fails open (skip the
   * check) rather than hanging Run indefinitely. */
  private async waitForLookupInputPreviewReady(timeoutMs: number): Promise<boolean> {
    const start = Date.now();
    const isReady = () => !!(this.lookupDataFarmPreviewTable?.displayedColumnInfos && this.inputDataFarmPreviewTable?.displayedColumnInfos);
    while (!isReady() && Date.now() - start < timeoutMs) {
      await new Promise(resolve => setTimeout(resolve, 200));
    }
    return isReady();
  }

  async setDefaultValues(transformType:TransformType): Promise<void>{
    const selectedNode=this.userData.getSelectedNodeDetails();
    // Same self-heal as setTransformerDetails() (base-transformer-ui.component.ts) -- this is
    // called from onRouteActivated right after that one, so it's exposed to the exact same
    // timing race against AppComponent's master-config fetch.
    let allMasterTransformers = this.userData.getMasterTransformers();
    if(!allMasterTransformers || allMasterTransformers.length === 0){
      const masterconfigs = await this.configService.getMasterConfigs();
      this.userData.setMasterNodeBoxTypes(masterconfigs.nodeboxtypes);
      this.userData.setMasterTransformers(masterconfigs.transformers);
      this.userData.setMasterFarmtypes(masterconfigs.farmtypes);
      allMasterTransformers = masterconfigs.transformers;
    }
    const masterconfig=allMasterTransformers.find(x=>x.id==transformType);
    var parameters=masterconfig?.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid);
    if(parameters){
      var params=parameters.parameters;
      //other parameters
      this.defKeyField=params.find(x=>x.jsonobject=='defKeyField');
      this.defLookupField=params.find(x=>x.jsonobject=='defLookupField');
      this.lookupFarm=params.find(x=>x.jsonobject=='lookupFarm');
      this.lookupDedup=params.find(x=>x.jsonobject=='lookupDedup');
      this.resetRows=params.find(x=>x.jsonobject=='resetRows');
      this.overwriteRows=params.find(x=>x.jsonobject=='overwriteRows');
      //advanced settings parameters
      //check this is first this.viewModel.sampleEnd =0
      if((this.viewModel.sampleEnd-1)==0 || isNaN(this.viewModel.sampleEnd)){
        //other parameters
        for(let pr of this.defKeyField.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.defKeyField=foundColumn.value;
            break;
          }
        }
        if(this.lookupDedup.default!=""){
          this.viewModel.lookupDedup=Number(this.lookupDedup.default);
        }
        if(this.resetRows.default!=""){
          this.viewModel.resetRows=this.stringToBoolean(this.resetRows.default);
        }
        if(this.overwriteRows.default!=""){
          this.viewModel.overwriteRows=this.stringToBoolean(this.overwriteRows.default);
        }
        //advanced settings parameters
      }
    }else{
      //advanced settings parameters
      // this.bufferRows.label="Buffer Rows";this.bufferRows.jsonobject="bufferRows";this.bufferRows.min=0;this.bufferRows.max=10000000;
      // this.resetRows.label="Reset Row Numbers";this.resetRows.jsonobject="resetRows";
    }
  }
  async removeInvalidValues(): Promise<void>{
    //other parameters
    //advanced settings parameters
  }
  async loadImportTransformer(transform: any): Promise<void>{
      const busyIndicator = this.showBusyDialog('Please wait...');
      try{
        if(this.userData.getSelectedNodeDetails().farmtypeid!=transform.farmType){
          this.displayError("Current DataFarmType is " + DataFarmTypeUtil.toString(this.userData.getSelectedNodeDetails().farmtypeid) + ". But you are trying to load a different DataFarmType: " + DataFarmTypeUtil.toString(transform.farmType),"Error");
          return;
        }else if(this.transformType!=transform.transformType){
          this.displayError("Current transform is " + TransformTypeUtil.toString(this.transformType) + ". But you are trying to load a different transform type: " + TransformTypeUtil.toString(transform.transformType),"Error");
          return;
        }
        var ctranformconfig=this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid);
        ctranformconfig.transform.transformConfig=transform;
        var newmodel =new ColumnLookupTransformDetailViewModel(this.dataDictService,this.configService,this.dataTransformConfigViewModel,ctranformconfig);
        // force new object reference for UI refresh
        this.viewModel.rules=[];
        this.viewModel.rules=[...newmodel.rules];
        this.isRuleSetEmpty = this.viewModel.rules.length === 0;
        this.dataSource.data = this.viewModel.rules;
        //update Parameters
        this.viewModel.parameters.sortInfo=newmodel.parameters.sortInfo;
        this.viewModel.parameters.includeInResults=newmodel.parameters.includeInResults;
        this.viewModel.parameters.sampleStart =newmodel.parameters.sampleStart;
        this.viewModel.parameters.sampleEnd =newmodel.parameters.sampleEnd;
        this.viewModel.parameters.runAll =newmodel.parameters.runAll;
        //other parameters
        //this.viewModel.groupBy = newmodel.groupBy;
        this.viewModel.defKeyField = newmodel.defKeyField;
        this.viewModel.defLookupField = newmodel.defLookupField;
        this.viewModel.lookupFarm = "";//newmodel.lookupFarm;
        this.viewModel.lookupFarmType = "";//newmodel.lookupFarmType;
        this.viewModel.lookupDedup = newmodel.lookupDedup;
        //advanced settings parameters
        this.viewModel.overwriteRows = newmodel.overwriteRows;
        this.viewModel.resetRows = newmodel.resetRows;
        //update rule table height
        if(this.viewModel.rules.length<=10){
          this.minrowcount=this.viewModel.rules.length;
        }else{
          this.minrowcount=10;
        }
        this.maxrowcount=this.viewModel.rules.length;
      }catch (err) {
        this.displayError(`Failed to save import transformer`, 'Error', err);
      }finally {
        busyIndicator.close();
      }
    }
  
  async onRunTransformValidate() {
    if(!await this.validateRules()){
      this.displayError("Validation failed. Please correct the highlighted fields.","Validation Error");
      return;
    }
    await this.onRunTransform();
  }
}
